import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { IconButton, Paper, Tooltip, Typography } from '@mui/material';

import { AzureUploadFileArquivoProps } from 'components/azureUpload/types';

export function RevendedorFilesPaper({ files }: { files: AzureUploadFileArquivoProps[] }) {
    return (
        <>
            {files.reverse().map(({ dsLink, dsArquivo }) => (
                <Paper key={Math.random()} sx={{ display: 'flex', alignItems: 'center', p: 1.5, gap: 1, height: 54 }}>
                    <ArticleOutlinedIcon />

                    <Typography sx={{ mr: 'auto' }}>{dsArquivo}</Typography>

                    <Tooltip title="Visualizar">
                        <IconButton sx={{ p: 0.5 }} onClick={() => window.open(dsLink, '_blank')}>
                            <VisibilityOutlinedIcon />
                        </IconButton>
                    </Tooltip>
                </Paper>
            ))}
        </>
    );
}
